// Custom confirmation handler for year-end closing
document.addEventListener('turbolinks:load', function() {
  console.log('Year-end closing script loaded');
  
  // Find the year-end closing form
  const closeYearForm = document.querySelector('form[action*="close_year"]');
  
  if (closeYearForm) {
    console.log('Found close year form:', closeYearForm);
    
    // Find submit element - could be button or input type="submit"
    const submitElement = closeYearForm.querySelector('input[type="submit"], button[type="submit"]');
    console.log('Found submit element:', submitElement);
    
    if (!submitElement) {
      console.log('No submit element found');
      return;
    }
    
    // Remove default Rails confirm behavior by clearing data-confirm
    submitElement.removeAttribute('data-confirm');
    
    // Get the year from the form action URL
    const urlParams = new URLSearchParams(closeYearForm.action.split('?')[1]);
    const year = urlParams?.get('year') || '2024';
    
    // Add click handler to the submit element
    submitElement.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Submit clicked, showing confirmation prompt');
      console.log('Year:', year);
      
      // Show custom confirmation dialog
      const userInput = prompt(`Are you absolutely sure you want to close year ${year}?\n\nType 'YES' to confirm:`);
      
      console.log('User input:', userInput);
      
      if (userInput === 'YES') {
        console.log('User confirmed with YES, submitting form...');
        
        // User typed YES correctly, submit the form
        // Disable the button to prevent double submission
        submitElement.disabled = true;
        submitElement.value = 'Closing...';
        
        // Submit the form programmatically
        closeYearForm.submit();
      } else if (userInput !== null) {
        console.log('User did not type YES correctly');
        // User typed something but not YES
        alert('You must type "YES" (all caps) to confirm. Year-end closing cancelled.');
      } else {
        console.log('User cancelled the prompt');
      }
      // If userInput is null, user clicked Cancel, so do nothing
    });
    
    console.log('Event listener attached to submit element');
  } else {
    console.log('Close year form not found on this page');
  }
});

